"use client";
import { Carousel } from "@/components/common";
import { Link } from "@/i18n/routing";
import { PageTitle } from "@repo/components";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { blurImage, getStrapiMedia, shimmer, toBase64 } from "@repo/lib/utils";
import { MotionContainer } from "@repo/ui";
import Image from "next/image";

const Spaces = ({ data, locale }) => {
  const { title, description, influencers, isEnabled } = data;
  const fallBackImgWidth = 266;
  const fallBackImgSrc = `data:image/svg+xml;base64,${toBase64(
    blurImage(fallBackImgWidth, fallBackImgWidth)
  )}`;

  const isInfluencersEnabled = useFeatureFlag("influencers");

  if (influencers?.data?.length === 0 || !isEnabled || !isInfluencersEnabled)
    return null;

  return (
    <MotionContainer>
      <section className="mx-auto py-6 md:px-4 md:py-24">
        {title && (
          <PageTitle
            title={title}
            variant="small"
            className="font-heading rtl:font-arabic mb-5 text-center !text-2xl md:mb-9 md:!text-[32px]"
          />
        )}
        {description && (
          <p className="rtl:font-arabic mb-5 text-center text-sm font-medium md:mb-20 md:text-base">
            {description}
          </p>
        )}
        <Carousel
          items={influencers?.data || []}
          locale={locale}
          slideWidth="50%"
          renderItem={(item) => (
            <div className="mx-auto flex flex-col items-center justify-center px-2">
              <Link href={`/spaces/${item?.slug}`}>
                <Image
                  src={getStrapiMedia(item?.picture?.url) ?? fallBackImgSrc}
                  alt={item?.shortName}
                  width={item?.picture?.width || fallBackImgWidth}
                  height={item?.picture?.height || fallBackImgWidth}
                  placeholder={`data:image/svg+xml;base64,${toBase64(
                    shimmer(
                      item?.picture?.width || fallBackImgWidth,
                      item?.picture?.height || fallBackImgWidth
                    )
                  )}`}
                  className="min-h-32 rounded-full"
                />

                {item?.shortName && (
                  <p className="font-heading rtl:font-arabic py-3 text-center text-base font-medium md:text-xl">
                    {item?.shortName}
                  </p>
                )}
              </Link>
            </div>
          )}
        />
      </section>
    </MotionContainer>
  );
};

export default Spaces;
